export default "__VITE_ASSET__CMGK3pGi__"